import React, { useState } from 'react'
import PropTypes from 'prop-types'

import Plain from './Plain'
import Edit from './Edit'

const DevPlanCard = ({
  actionSteps,
  title,
  planId,
  date,
  onMoveUp,
  onMoveDown,
  isFirst,
  isLast
}) => {
  const [editMode, setEditMode] = useState(false)
  const sortedSteps = [...actionSteps].sort(
    (a, b) => a.sortOrder - b.sortOrder
  )

  const toggleEditMode = () => setEditMode(!editMode)
  return editMode ? (
    <Edit
      planId={planId}
      actionSteps={sortedSteps}
      title={title}
      toggleEditMode={toggleEditMode}
    />
  ) : (
    <Plain
      planId={planId}
      actionSteps={sortedSteps}
      title={title}
      toggleEditMode={toggleEditMode}
      date={date}
      onMoveUp={onMoveUp}
      onMoveDown={onMoveDown}
      isFirst={isFirst}
      isLast={isLast}
    />
  )
}

DevPlanCard.propTypes = {
  planId: PropTypes.number,
  actionSteps: PropTypes.array,
  title: PropTypes.string,
  date: PropTypes.string,
  onMoveUp: PropTypes.func,
  onMoveDown: PropTypes.func,
  isFirst: PropTypes.bool,
  isLast: PropTypes.bool
}

export default DevPlanCard
